import type { InboxThreadStatus } from '@travel-planner/shared/schemas/inbox-threads';
import { inboxThreadStatusEnum } from '@travel-planner/shared/schemas/inbox-threads';

export type InboxSortOrder = 'newest' | 'oldest' | 'stalled';

export type InboxSearch = {
  q?: string;
  status?: InboxThreadStatus;
  cursor?: string;
  sort?: InboxSortOrder;
};

const STATUS_VALUES = Object.values(
  inboxThreadStatusEnum.enum
) as ReadonlyArray<string>;

const SORT_VALUES: ReadonlyArray<string> = ['newest', 'oldest', 'stalled'];

const asStatus = (v: unknown): InboxThreadStatus | undefined =>
  typeof v === 'string' && STATUS_VALUES.includes(v)
    ? (v as InboxThreadStatus)
    : undefined;

const asSort = (v: unknown): InboxSortOrder | undefined =>
  typeof v === 'string' && SORT_VALUES.includes(v)
    ? (v as InboxSortOrder)
    : undefined;

export const validateInboxSearch = (
  input: Record<string, unknown>
): InboxSearch => ({
  q: typeof input.q === 'string' ? input.q : undefined,
  status: asStatus(input.status),
  cursor: typeof input.cursor === 'string' ? input.cursor : undefined,
  sort: asSort(input.sort),
});
